// bootstrap/errorHandlers.js
import { reloadWithCacheBust } from '@/utils/cacheBust'

const CHUNK_ERROR_PATTERNS = [
	/loading( css)? chunk \d+ failed/i,
	/failed to fetch dynamically imported/i,
	/error loading dynamically imported module/i,
	/importing a module script failed/i
]

let handlersRegistered = false

export function setupErrorHandlers (router) {
	if (handlersRegistered) return
	handlersRegistered = true

	router.VueRouter.onError(err => handleChunkError(err))

	window.addEventListener('error', (event) => handleChunkError(event.error))
	window.addEventListener('unhandledrejection', (event) => handleChunkError(event.reason))
}

function isChunkError (error) {
	const msg = error?.message || String(error)
	return CHUNK_ERROR_PATTERNS.some(pattern => pattern.test(msg))
}

function handleChunkError (error) {
	if (!isChunkError(error)) return

	console.error('[chunkError] Chunk load failed, reloading with cache bust:', error?.message || error)
	reloadWithCacheBust()
}
